import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import i18next from "i18next";

const APP_NAME = "WiServices";

const routeTitleMap: Record<string, string> = {
  "/": "page.title.dashboard",
  "/dashboard": "page.title.dashboard",
  "/resources/vms": "page.title.virtualMachines",
  "/resources/disks": "page.title.disks",
  "/resources/networks": "page.title.networks",
  "/resources/storage": "page.title.objectStorage",
  "/resources/create": "page.title.createVM",
  "/resources/storage/create": "page.title.createStorage",
  "/orders": "page.title.orders",
  "/billing": "page.title.billing",
  "/billing/balance": "page.title.balance",
  "/billing/add-balance": "page.title.addBalance",
  "/billing/deposit": "page.title.deposit",
  "/billing/payment-history": "page.title.paymentHistory",
  "/billing/invoices": "page.title.invoices",
  "/billing/payment-methods": "page.title.paymentMethods",
  "/settings/profile": "page.title.profile",
  "/settings/security": "page.title.security",
  "/settings/preferences": "page.title.preferences",
  "/settings/api-keys": "page.title.apiKeys",
  "/logs": "page.title.logs",
  "/account/connected-accounts": "page.title.connectedAccounts",
};

function getTitleKey(pathname: string): string | null {
  if (routeTitleMap[pathname]) return routeTitleMap[pathname];

  if (pathname.match(/^\/resources\/[a-f0-9-]+$/)) return "page.title.vmDetail";
  if (pathname.match(/^\/resources\/disks\/[a-f0-9-]+$/))
    return "page.title.diskDetail";
  if (pathname.match(/^\/resources\/networks\/[a-f0-9-]+$/))
    return "page.title.networkDetail";
  if (pathname.match(/^\/resources\/storage\/[a-f0-9-]+$/))
    return "page.title.storageDetail";
  if (pathname.match(/^\/orders\/[a-f0-9-]+$/)) return "page.title.orderDetail";
  if (pathname.match(/^\/billing\/payment\//))
    return "page.title.paymentStatus";

  if (pathname === "/settings") return "page.title.settings";

  const prefix = Object.keys(routeTitleMap)
    .filter((key) => key !== "/" && pathname.startsWith(key + "/"))
    .sort((a, b) => b.length - a.length)[0];
  if (prefix) return routeTitleMap[prefix];

  return null;
}

export function useDocumentTitle(detailName?: string) {
  const location = useLocation();

  useEffect(() => {
    const titleKey = getTitleKey(location.pathname);
    if (titleKey) {
      const pageTitle = i18next.t(`common:${titleKey}`, {
        defaultValue: titleKey,
      });
      const detail = detailName ? ` - ${detailName}` : "";
      document.title = `${pageTitle}${detail} | ${APP_NAME}`;
    }
  }, [location.pathname, detailName]);
}
